import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';

import reducer from './reducer';

const reduxDevTools =
  window.__REDUX_DEVTOOLS_EXTENSION__ && process.env.NODE_ENV !== 'production'
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : f => f;

const store = createStore(
  reducer,
  {},
  compose(
    applyMiddleware(thunkMiddleware),
    reduxDevTools
  )
);

export { store };



// WEBPACK FOOTER //
// ./src/configureStore.js